'use client';

import React from 'react';
import styles from './ExpertiseStatsSection.module.css';

interface Stat {
  value: string;
  label: string;
}

interface ExpertiseStatsSectionProps {
  badge?: string;
  title: string;
  intro?: string;
  features?: string[];
  stats: Stat[];
  footer?: string;
  highlights?: string[];
}

export function ExpertiseStatsSection({
  badge,
  title,
  intro,
  features,
  stats,
  footer,
  highlights
}: ExpertiseStatsSectionProps) {
  return (
    <section className={styles.expertiseStats}>
      <div className={styles.container}>
        {/* Header */}
        {badge && <div className={styles.badge}>{badge}</div>}
        
        <h2 className={styles.title}>{title}</h2>
        
        {intro && <p className={styles.intro}>{intro}</p>}

        {/* Features List (Compact - checkmark + text only) */}
        {features && features.length > 0 && (
          <div className={styles.featuresList}>
            {features.map((feature, index) => (
              <div key={index} className={styles.featureItem}>
                <svg className={styles.checkmark} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 12L10.5 15.5L17 9" stroke="url(#gradient)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <defs>
                    <linearGradient id={`gradient-${index}`} x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#FF9966" />
                      <stop offset="100%" stopColor="#FF5E62" />
                    </linearGradient>
                  </defs>
                </svg>
                <span className={styles.featureText}>{feature}</span>
              </div>
            ))}
          </div>
        )}

        {/* Stats Grid */}
        <div className={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statItem}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Highlights (Optional - Inline badges style) */}
        {highlights && highlights.length > 0 && (
          <div className={styles.highlights}>
            {highlights.map((highlight, index) => (
              <span key={index} className={styles.highlightBadge}>{highlight}</span>
            ))}
          </div>
        )}

        {/* Footer */}
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </section>
  );
}

